import { Color23, Colors23 } from '@grammarly/badger-ui'

interface IconCloseProps {
  color?: Color23
}

export const IconClose = ({ color, ...rest }: IconCloseProps) => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" {...rest}>
    <path
      d="M1 1L6.5 6.5M12 12L6.5 6.5M6.5 6.5L12 1M6.5 6.5L1 12"
      stroke={color ? Colors23[color] : 'currentColor'}
      strokeLinecap="round"
    />
  </svg>
)
